export default "__VITE_ASSET__DYD8tYbb__"